import _ from "lodash";
import { fetchProviderFilterMetadata } from "./fetchProviderFilterMetadata";
import { queryWaterProvider } from "./api";
import { FilterMetadataApiReturn, FilterMetadataApiWithCountReturn, WaterProvider } from "./types";
import { QUERY_URL_AND } from "./constants";

export const getFacetFieldWithMetadata = (metadata: FilterMetadataApiReturn) => {
    if (!metadata) return undefined;

    const facetQuery = _.join(
        _.toPairs(metadata)
            .map(([__, { options }]) => {
                const fields = _.uniq(
                    (options ?? []).map(({ access }) => access).filter(d => d != null && d.toString().trim() !== "")
                ).filter(d => d != null && d?.toString()?.trim() !== "");

                if (!fields?.length) return undefined;

                return _.join(
                    fields.map(field => `facet.field=${field}`),
                    QUERY_URL_AND
                );
            })
            .filter(queryPart => queryPart !== undefined),
        QUERY_URL_AND
    );

    return facetQuery;
};

export const constructFacetFieldValues = (providers: WaterProvider[] = []) => {
    if (!providers?.length) {
        return {
            pure_strings_connection_size_ct: [],
            pure_strings_region: [],
            pure_strings_type: []
        };
    }
    const providerTypeToProviders = _.groupBy(providers, d => d.type);
    const providerRegionToProviders = _.groupBy(providers, d => d.region);
    const providerConnectionSizeToProviders = _.groupBy(providers, d => d.connectionSizeCategory);

    const facetValues = [providerTypeToProviders, providerRegionToProviders, providerConnectionSizeToProviders].map(
        group =>
            _.keys(group)?.reduce((prev, cur) => {
                prev = [...prev, cur, group[cur]?.length];
                return prev;
            }, [] as (string | number)[])
    );

    return {
        pure_strings_connection_size_ct: facetValues?.[2],
        pure_strings_region: facetValues?.[1],
        pure_strings_type: facetValues?.[0]
    };
};

export const fetchProviderFilterMetadataCount = async (
    metadata: FilterMetadataApiReturn,
    options?: RequestInit
): Promise<FilterMetadataApiWithCountReturn> => {
    // create a facet query string from query params
    const facetQuery = getFacetFieldWithMetadata(metadata);
    if (!facetQuery) return undefined;

    // const fieldQuery = `fq=pure_strings_connection_size_ct: (NOT "bulk")`;

    const response = await queryWaterProvider(
        _.join(
            [
                "q=*:*",
                "rows=0",
                "facet=on",
                //fieldQuery,
                facetQuery
            ],
            QUERY_URL_AND
        ),
        options
    );
    const facetFields = response?.facet_counts?.facet_fields ?? {};

    const facetFieldToFacetCategory = {};
    _.keys(facetFields).forEach(field => {
        facetFieldToFacetCategory[field] = _.chunk(facetFields[field] ?? [], 2).reduce<Record<string, number>>(
            (prev, [key, value]) => {
                prev[`${key}`] = parseFloat(value.toString());
                return prev;
            },
            {}
        );
    });

    // finalise query params with count
    const ret = _.toPairs(metadata)
        .map(([key, { options, defaults, label }]) => {
            const fields = _.uniq(
                (options ?? []).map(({ access }) => access).filter(d => d != null && d.toString().trim() !== "")
            ).filter(d => d != null && d?.toString()?.trim() !== "");

            let amount = 0;
            if (!fields?.length) return undefined;

            const optionsWithAmount = options.map(d => {
                return {
                    ...d,
                    amount: facetFieldToFacetCategory?.[d.access]?.[d.value] ?? amount
                };
            });

            return {
                key,
                defaults,
                label,
                options: optionsWithAmount
            };

            // if (!facetFields[field]) {
            //     return {
            //         key,
            //         defaults,
            //         label,
            //         options: options.map(d => {
            //             return {
            //                 ...d,
            //                 amount
            //             };
            //         })
            //     };
            // }

            // const keyToAmount = _.chunk(facetFields[field] ?? [], 2).reduce<Record<string, number>>(
            //     (prev, [key, value]) => {
            //         prev[`${key}`] = parseFloat(value.toString());
            //         return prev;
            //     },
            //     {}
            // );

            // return {
            //     key,
            //     defaults,
            //     label,
            //     options: options.map(({ value, ...rest }) => {
            //         return {
            //             ...rest,
            //             value,
            //             amount: keyToAmount?.[value] ?? 0
            //         };
            //     })
            // };
        })
        .filter(queryPart => queryPart !== undefined)
        .reduce<FilterMetadataApiWithCountReturn>((prev, { key, ...rest }) => {
            prev[key] = rest;
            return prev;
        }, {});

    return ret;
};

export const fetchProviderFilterMetadataWithCount = async (
    options?: RequestInit
): Promise<FilterMetadataApiWithCountReturn> => {
    const metadata = await fetchProviderFilterMetadata(options);
    return await fetchProviderFilterMetadataCount(metadata, options);
};
